<div *ngFor="let shippingItemType of shippingItemTypes; let i = index" class="mb-30">
  <div class="mct-flex mct-col">
    <div class="mct-flex mct-row">
      <label style="margin-right: 280px">{{ 'ecommerce.item.shipping.type' | translate | ucfirst }}</label>

      <button
        pButton
        type="button"
        class="mct-flex btn btn-text mct-justify-end mct-items-stretch"
        (click)="deleteShippingItemType(shippingItemType)"
        icon="pi pi-trash"
        style="color: red; font-size: 1.5rem"
      ></button>
    </div>

    <p-select
      appendTo="body"
      name="ShippingType"
      [options]="shippingTypes"
      [(ngModel)]="shippingItemType.ShippingTypeId"
      [placeholder]="'common.select-dashes' | translate | ucfirst"
      [style]="{ width: '60%' }"
      showClear
      (onChange)="updateShippingItemType()"
    ></p-select>
  </div>

  <div>
    <label>{{ 'ecommerce.item.shipping.fixed-price' | translate | ucfirst }}</label>
    <div class="mct-flex mct-row mct-justify-between mct-items-center mct-gap-27">
      <div class="p-inputgroup mct-basis-40">
        <span class="atlas-input-addon">$</span>
        <input type="currency" class="form-control" [(ngModel)]="shippingItemType.FixedAmount" (change)="updateShippingItemType()" />
      </div>
      <span class="mct-basis-60">{{ 'ecommerce.item.shipping.fixed-price-desc' | translate | ucfirst }}</span>
    </div>
  </div>

  <div>
    <label>{{ 'ecommerce.item.shipping.variable-price' | translate | ucfirst }}</label>
    <div class="mct-flex mct-row mct-justify-between mct-items-center mct-gap-27">
      <div class="p-inputgroup mct-basis-40">
        <span class="atlas-input-addon">$</span>
        <input type="currency" class="form-control" [(ngModel)]="shippingItemType.VariableAmount" (change)="updateShippingItemType()" />
      </div>
      <span class="mct-basis-60">{{ 'ecommerce.item.shipping.variable-price-desc' | translate | ucfirst }}</span>
    </div>
  </div>
</div>

<div class="mct-flex mct-row mct-justify-end mct-items-center">
  <button
    app-add-button
    [style]="{'border-color': '#2273a3', 'color': '#2273a3', 'height': '30px'}"
    [label]="'ecommerce.item.shipping.add-shipping-type-btn' | translate | ucfirst"
    (click)="addShippingItemType()">
  </button>
</div>
